import { InjectionToken } from '@angular/core';

/**
 * Bridge to AngularJS `ThemesHelperService`.
 *
 * ValidateService only reads company password-policy fields. The legacy
 * service is wider than this — the port only exposes what validate needs.
 */
export interface IThemesHelperPort {
  getCompany(key: string): unknown;
}

export const THEMES_HELPER_PORT = new InjectionToken<IThemesHelperPort>('THEMES_HELPER_PORT');
